<div class="stu-my-album">
  <div class="list-header">
    <button class="spen-mod-btn is-primary" routerLink="/albums/student/new">アルバムの新規作成</button>
  </div>

  @if (searchKeyword.length > 0) {
    <div class="filtering-albums">
      <div class="change-filter">
        <a class="spen-util-link" (click)="showFilterModal()"><i class="fa fa-search"></i>検索条件を変更</a>
      </div>
      <div class="album-detail">
        <span class="album-name">検索条件：{{ searchKeyword }}</span>
        <a class="remove-filter spen-util-link" (click)="removeAlbumFilter()">解除</a>
      </div>
    </div>
  } @else {
    <div class="not-filtering-albums">
      <a class="spen-util-link" (click)="showFilterModal()"><i class="fa fa-search"></i>検索</a>
    </div>
  }

  <div class="albums-list">
    @if (dataLoaded) {
      @if (albums.length > 0) {
        <div class="list-amount">
          <span>{{ albumsCount }}件</span>
        </div>
        <div class="album-content">
          <ul class="album-flex-list">
            @for (album of albums; track album.id) {
              <li class="list-item" routerLink="/albums/student/{{ album.id }}">
                <a class="list-item-info">
                  @if (!!album.image) {
                    <img class="default-image album-cover object-fit-cover" src="{{ album.image.thumbnail }}" />
                  } @else {
                    <img class="default-image" src="/assets/images/album.svg" />
                  }
                  <div class="text-info">
                    <p class="time-album">
                      @if (!album.is_read) {
                        <span class="spen-mod-badge is-red">NEW</span>
                      }
                      <span>{{ album.created_at | date: 'yyyy/MM/dd' }}</span>
                      @if (album.creator_type === 'teacher') {
                        <span class="album-creator-name"> {{ album.user.name }}先生 </span>
                      }
                    </p>
                    <p class="name-file">{{ album.title }}</p>
                  </div>
                </a>
                <a class="list-item-icon"><i class="fa fa-chevron-right"></i></a>
              </li>
            }
          </ul>
          <div class="block-footer">
            @if (showPagination) {
              <div class="pagination">
                <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="null-content">
          <p class="text">アルバムはありません。</p>
        </div>
      }
    } @else {
      <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
    }
  </div>
  @if (!isMobileApp) {
    <a href="{{ classiUrl }}" class="spen-mod-btn prev-button">ホームへ戻る</a>
  }
</div>

@if (isShowingFilterModal) {
  <app-filter-album-modal [initSearchKeyword]="searchKeyword" (submitFilter)="onSubmitFilter($event)" (cancelFilter)="onCancelFilter()">
  </app-filter-album-modal>
}
